import React from 'react';
import {
  Edit, Picture, Music, Paperclip, Clipboard,
  Nutrition as NutritionIcon, ReadBook, FileText,
  Link as LinkIcon,
  Video as VideoIcon,
  Minus as MinusIcon,
  BackgroundColor as PaintIcon,
} from '@icon-park/react';

/**
 * 内容类型图标映射
 */
export function getContentIcon(type) {
  const commonProps = { theme: 'outline', size: 18, fill: '#333', strokeWidth: 3 };
  const icons = {
    text: <Edit {...commonProps} />,
    image: <Picture {...commonProps} />,
    background: <PaintIcon {...commonProps} />,
    video: <VideoIcon {...commonProps} />,
    audio: <Music {...commonProps} />,
    link: <LinkIcon {...commonProps} />,
    attachment: <Paperclip {...commonProps} />,
    divider: <MinusIcon {...commonProps} />,
    'product-basic': <Clipboard {...commonProps} />,
    'nutrition': <NutritionIcon {...commonProps} />,
    'usage': <ReadBook {...commonProps} />,
    'related-links': <LinkIcon {...commonProps} />,
    'inspection': <FileText {...commonProps} />
  };
  return icons[type] || <FileText {...commonProps} />;
}

/**
 * 内容类型名称映射
 */
export function getContentName(type) {
  const names = {
    text: '文本',
    image: '图片',
    background: '背景',
    video: '视频',
    audio: '音频',
    link: '超链接',
    attachment: '附件',
    divider: '分隔线',
    'product-basic': '产品基础信息',
    'gi-product': 'GI 展示补充设置',
    'nutrition': '营养成分表',
    'usage': '食用方法',
    'related-links': '相关链接',
    'inspection': '检验报告'
  };
  return names[type] || type;
}

/**
 * 基础内容类型列表
 */
export const basicContentTypes = [
  { type: 'text', name: '文本', icon: 'Edit' },
  { type: 'image', name: '图片', icon: 'Picture' },
  { type: 'background', name: '背景', icon: 'Paint' },
  { type: 'video', name: '视频', icon: 'Video' },
  { type: 'audio', name: '音频', icon: 'Music' },
  { type: 'link', name: '超链接', icon: 'Link' },
  { type: 'attachment', name: '附件', icon: 'Paperclip' },
  { type: 'divider', name: '分隔线', icon: 'Minus' },
];

/**
 * 业务模板类型列表
 */
export const templateTypes = [
  { type: 'product-basic', name: '产品基础信息', icon: 'Clipboard' },
  { type: 'nutrition', name: '营养成分表', icon: 'Nutrition' },
  { type: 'usage', name: '食用方法', icon: 'ReadBook' },
  { type: 'related-links', name: '相关链接', icon: 'Link' },
  { type: 'inspection', name: '检验报告', icon: 'FileText' },
];
